export default __webpack_public_path__ + "static/Quickinstallation_Tile_8815_Step_02-5c6e4650d64211bc1956f798e6389012.webp";